import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "H5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { ref } from 'vue'
import { getPageListData } from '@/service/main/system'
import useClipboard from 'vue-clipboard3'
import { ElNotification } from 'element-plus'
import { generateRandomString } from '@/utils/utils'
import { getGenerateLink } from '@/service/main/h5/generate'
import { getGeneratUrl } from '@/service/main/fubo/generate'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccessLink',
  setup(__props) {

const modalTitle = ref('新增')
const newCb = () => {
  modalTitle.value = '新增H5链接'
}

const editCb = () => {
  modalTitle.value = '编辑H5链接'
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

const { toClipboard } = useClipboard()

const generate = async (id: string) => {
  const link = await getGenerateLink(id)
  try {
    await toClipboard(link)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}

const handleQrCode = (row: any) => {
  debugger
  const url = `/main/fuboGenerate/generate/qrcode/h5/${row.id}`
  getPageListData(url, null, 'blob').then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    debugger
    const down = document.createElement('a')
    down.download = `${row.title}.jpg`
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "h5",
      deleteTip: "确认删除H5链接吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onQrCodeClick: handleQrCode
    }, {
      type: _withCtx((scope) => [
        (scope.row.type === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "网页"))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, "小程序"))
      ]),
      link: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          onClick: ($event: any) => (generate(scope.row.id))
        }, {
          default: _withCtx(() => [
            _createTextVNode("点击复制 ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "h5",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})